<template>
  <div :class="{ loading: loading }">
    <ul class="list-group table-header">
      <li class="list-group-item active table-header-inner">
        <div class="col-md-2 bmd-list-group-col dashboard_table_name">
          <p class="list-group-item-heading">
            Dashboard
            <span
              ><span class="table-period-header"
                >({{ userReportingPeriod }})</span
              ></span
            >
          </p>
        </div>
        <div class="d-flex">
          <input
            type="text"
            class="search-input"
            placeholder="Search..."
            v-model="search"
          />
          <div class="btn toggle-button" @click="toggleAll()">
            <span>{{ toggleButtonText === "Toggle" ? lang.expand : lang.collapse }}</span>
          </div>
          <div class="columns-editor-container exclude">
            <div
              class="btn btn-outline btn-light exclude"
              @click="showColumnEditor = !showColumnEditor"
            >
              <span class="exclude">{{ lang.customize_columns }}</span>
            </div>
            <ColumnEditor
              v-if="showColumnEditor"
              :selected-headers="headersWithFixed"
              :available-headers="availableHeaders"
              @sorted="headersSorted"
              @toggle="toggleHeader"
              @resetHeaders="resetHeaders"
              @saveHeaders="saveHeaders"
              v-clickAway="{
                exclude: ['exclude'],
                handler: 'closeColumnEditor',
              }"
            />
          </div>
          <div class="col-md-4 bust_cache_container dashboard grouping_container">
            <DropDownGroupSelector :groupOptions="groups"/>
          </div>
          <button class="btn btn-success btn-refresh" @click="bustCache">
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              ></path>
            </svg>
          </button>
        </div>
      </li>
    </ul>
    <v-app>
      <v-content>
        <v-data-table
          v-if="renderComponent"
          :headers="headersWithFixed"
          :items="filteredData"
          item-key="name"
          group-key="groupKey"
          :group-expanded="expanded"
          ref="table"
          :search="search"
          :loading="loading"
          :group-sort-descending="pagination.descending"
          :pagination="pagination"
          hide-actions
          @update:pagination="updatePagination"
          style="--margin-left: 365px"
        >
          <template slot="headers" slot-scope="props">
            <tr v-if="selectedRows.length > 0" class="actions">
              <th
                class="column"
                style="display: inline-flex; align-items: center"
              >
                <CustomCheckbox
                  :checked="selectedRows.length > 0"
                  :check-all="true"
                  @selectAll="selectAll"
                  @deselectAll="deselectAll"
                  class="mr-2"
                />
                {{ selectedRows.length }} selected
              </th>
              <th class="column">
                <BulkEditDropdown
                  :options="bookkeepingStatusOptions"
                  placeholder="Set bookkeeping status"
                  @action="bulkEdit"
                ></BulkEditDropdown>
              </th>
              <th class="column">
                <BulkEditDropdown
                  :options="reportStatusOptions"
                  placeholder="Set report status"
                  @action="bulkEdit"
                ></BulkEditDropdown>
              </th>
              <th class="column">
                <BulkEditDropdown
                  :options="vatStatusOptions"
                  placeholder="Set VAT status"
                  @action="bulkEditVatStatus"
                ></BulkEditDropdown>
              </th>
            </tr>
            <tr>
              <th width="65px" class="fixed-column" style="left: 0px">
                <CustomCheckbox
                  :checked="selectedRows.length > 0"
                  :check-all="true"
                  @selectAll="selectAll"
                  @deselectAll="deselectAll"
                />
              </th>
              <th
                v-for="header in props.headers"
                :key="header.value"
                :class="[
                  'column sortable text-xs-left active',
                  header.fixed ? 'fixed-column last-fixed-column' : '',
                  filters[header.value] && filters[header.value].length > 0
                    ? 'filtered'
                    : '',
                ]"
                :style="header.fixed ? 'margin-left: 65px;' : ''"
                :width="header.width"
              >
                <span
                  @click="
                    $eventBus.$emit(`toggleFilterOptions:${header.value}`)
                  "
                >
                  <span class="v-badge" v-if="header.filterable">
                    <span
                      v-if="filters[header.value].length > 0"
                      class="badge-wrapper"
                    >
                      <span class="badge">{{
                        filters[header.value].length
                      }}</span>
                    </span>
                    <v-icon color="dark" class="ml-1 exclude">
                      filter_list
                    </v-icon>
                  </span>
                </span>
                <span @click="changeSort(header.value)">
                  {{ header.text }}
                </span>
                <span v-if="header.value == 'name'">
                  <ArrowUpIcon v-if="!pagination.descending" />
                  <ArrowDownIcon v-if="pagination.descending" />
                </span>

                <FilterOptions
                  v-if="header.filterable"
                  :options="columnValueList(header.value)"
                  :value="header.value"
                  :activeFilters="filters[header.value]"
                  @setFilter="setFilters"
                  @clearFilter="clearFilters"
                ></FilterOptions>
              </th>
            </tr>
          </template>

          <template slot="group" slot-scope="props">
            <td
                class="fixed-column checkbox-column"
                style="width: 65px; left: 0"
            >
              <!-- check=isAlreadyChecked, Props=GroupName -->
              <custom-company-checkbox
                  :checked="selectedRows.includes(props.group)"
                  :value=props.groupName
                  @toggleCompany="toggleGroupCompanies"
              />
            </td>
            <td
                class="fixed-column text-center group-title"
            >
              <span
                v-if="props.groupName"
                :class="[
                {
                  'hide-group-header': 
                  companyGroups[props.groupName].length === 1 && !companyGroups[props.groupName][0].group,
                  'company-group': 
                  companyGroups[props.groupName].length >= 1 && companyGroups[props.groupName][0].group
                },
              ]"
              >
              {{ props.groupName }}
            </span>
            </td>
          </template>

          <template slot="items" slot-scope="props">
            <tr
              :id="props.item.slug"
              :class="[
                'relative',
                selectedRows.includes(props.item.id) ? 'selected' : '',
                {
                  'is-in-group': props.item.name !== props.item.groupKey,
                },
              ]"
              style="--margin-left: 65px"
            >
              <td
                class="fixed-column checkbox-column"
                style="width: 65px; left: 0"
              >
                <CustomCheckbox
                  :checked="selectedRows.includes(props.item.id)"
                  :value="props.item.id"
                  @toggleRow="toggleSelectedRow"
                />
              </td>
              <td
                v-for="header in headersWithFixed"
                :data-id="props.item.id"
                :key="header.value"
                :width="header.width"
                :style="header.fixed ? 'margin-left: 65px;' : ''"
                :class="[
                  header.fixed ? 'fixed-column last-fixed-column' : '',
                  {
                    'text-center':
                      header.value !== 'keepers_employees' &&
                      header.value !== 'services',
                  },
                ]"
              >
                <use-component
                  :is="toPascalCase(header.value)"
                  :data="props.item"
                  :status-options="statusOptions"
                  :key="props.item.id"
                  @updateDataField="updateDataField"
                  @setVatStatus="setVatStatus"
                  @toggleSalaryOutput="toggleSalaryOutput"
                ></use-component>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-content>
    </v-app>
    <Snackbar ref="snackbar" />
  </div>
</template>

<script>
import BulkEditDropdown from "./BulkEditDropdown.vue";
import ArrowDownIcon from "./ArrowDownIcon.vue";
import ArrowUpIcon from "./ArrowUpIcon.vue";
import CustomCheckbox from "./CustomCheckbox.vue";
import FilterOptions from "./FilterOptions.vue";
import axios from "axios";
import lodash from "lodash";
import Name from "./Name.vue";
import KeepersEmployees from "./KeepersEmployees.vue";
import Status from "./Status.vue";
import Deadline from "./Deadline.vue";
import ReportStatus from "./ReportStatus.vue";
import ReportDeadline from "./ReportDeadline.vue";
import VatStatus from "./VatStatus.vue";
import VatDeadline from "./VatDeadline.vue";
import AccoutingYear from "./AccoutingYear.vue";
import OutputSalary from "./OutputSalary.vue";
import VatFrequency from "./VatFrequency.vue";
import Weekday from "./Weekday.vue";
import UpdateFrequency from "./UpdateFrequency.vue";
import Postings from "./Postings.vue";
import ActualVsContract from "./ActualVsContract.vue";
import ActiveServices from "./ActiveServices.vue";
import HandledVouchers from "./HandledVouchers.vue";
import ReloadOnDemand from "./ReloadOnDemand.vue";
import ColumnEditor from "./ColumnEditor.vue";
import Snackbar from "./Snackbar.vue";
import CustomCompanyCheckbox from "./CustomCompanyCheckbox";
import DropDownGroupSelector from './DropDownGroupSelector.vue';

let handleOutsideClick;
export default {
  components: {
    CustomCompanyCheckbox,
    Name,
    KeepersEmployees,
    Status,
    Deadline,
    ReportStatus,
    ReportDeadline,
    VatStatus,
    VatDeadline,
    AccoutingYear,
    OutputSalary,
    VatFrequency,
    Weekday,
    UpdateFrequency,
    Postings,
    ActualVsContract,
    ActiveServices,
    HandledVouchers,
    ReloadOnDemand,
    ColumnEditor,
    Snackbar,
    FilterOptions,
    CustomCheckbox,
    ArrowUpIcon,
    ArrowDownIcon,
    BulkEditDropdown,
    DropDownGroupSelector,
  },
  props: {
    groups: {
      type: Object,
      requried: true,
    },
    userReportingPeriod: {
      type: String,
      requried: true,
    },
    lang: {
      type: Object,
      required: true,
    },
  },
  directives: {
    clickAway: {
      // for click away events
      bind(el, binding, vnode) {
        // Here's the click/touchstart handler
        // (it is registered below)
        handleOutsideClick = (e) => {
          e.stopPropagation();
          // Get the handler method name and the exclude array
          // from the object used in v-closable
          const { handler, exclude } = binding.value;
          // This variable indicates if the clicked element is excluded
          let clickedOnExcludedEl = false;
          exclude.forEach((refName) => {
            // We only run this code if we haven't detected
            // any excluded element yet
            if (!clickedOnExcludedEl) {
              clickedOnExcludedEl = e.target.classList.value.includes(refName);
            }
          });
          // We check to see if the clicked element is not
          // the dialog element and not excluded
          if (!el.contains(e.target) && !clickedOnExcludedEl) {
            // If the clicked element is outside the dialog
            // and not the button, then call the outside-click handler
            // from the same component this directive is used in
            vnode.context[handler]();
          }
        };
        // Register click/touchstart event listeners on the whole page
        document.addEventListener("click", handleOutsideClick);
        document.addEventListener("touchstart", handleOutsideClick);
      },
      unbind() {
        // If the element that has v-closable is removed, then
        // unbind click/touchstart listeners from the whole page
        document.removeEventListener("click", handleOutsideClick);
        document.removeEventListener("touchstart", handleOutsideClick);
      },
    },
  },
  watch: {
    search() {
      this.$nextTick(() => {
        this.fixGroupHeaders();
      });
    },
    selectedHeaders: {
      deep: true,
      handler() {
        this.DoubleScroll(document.querySelector(".v-table__overflow"));
      },
    },
    filters: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.fixGroupHeaders();
        });
      },
    },
    pagination: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.fixGroupHeaders();
        });
      },
    },
  },
  computed: {
    headersWithFixed() {
      let headers = this.selectedHeaders.filter((header) => {
        return header.value !== "name";
      });
      if (this.fixedHeader) {
        headers.unshift(this.fixedHeader);
      }
      return headers;
    },
    companyGroups() {
      return lodash.groupBy(this.data, "groupKey");
    },
    filteredData() {
      let data = this.data.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          if (f == "keepers_employees") {
            let allEmployees = [];
            d[f].forEach((item) => {
              allEmployees = allEmployees.concat(item.name);
            });
            let showRow = false;
            for (let i = 0; i < this.filters[f].length; i++) {
              const filter = this.filters[f][i];
              if (allEmployees.indexOf(filter) > -1) {
                showRow = true;
                break;
              }
            }
            return this.filters[f].length < 1 || showRow;
          }

          return (
            this.filters[f].length < 1 ||
            (typeof d[f] == "object"
              ? d[f]["text"]
                ? this.filters[f].includes(d[f]["text"])
                : this.filters[f].includes(d[f][0])
              : this.filters[f].includes(d[f]))
          );
        });
      });

      return this.sortData(data);
    },
    companyIds() {
      return this.filteredData.map((item) => {
        return item.id;
      });
    },
    bookkeepingStatusOptions() {
      return this.statusOptions.filter((status) => {
        return status.data_field_group == "bookkeeping_status";
      });
    },
    reportStatusOptions() {
      return this.statusOptions.filter((status) => {
        return status.data_field_group == "report_status";
      });
    },
    vatStatusOptions() {
      return this.statusOptions.filter((status) => {
        return status.data_field_group == "vat_status";
      });
    },
  },
  data() {
    return {
      selectAllRows: false,
      selectedRows: [],
      group: "my_clients",
      data: [],
      selectedHeaders: [],
      availableHeaders: [],
      statusOptions: [],
      originalHeaders: [],
      snackbar: true,
      fixedHeader: null,
      renderComponent: true,
      loading: true,
      search: "",
      sortBy: "name",
      sortDesc: false,
      showColumnEditor: false,
      pagination: {
        sortBy: "name",
        descending: false,
        page: 1,
        rowsPerPage: -1,
      },
      expanded: true,
      filters: {
        name: [],
        keepers_employees: [],
        status: [],
        deadline: [],
        report_status: [],
        report_deadline: [],
        vat_status: [],
        vat_deadline: [],
        accouting_year: [],
        output_salary: [],
        vat_frequency: [],
        weekday: [],
        update_frequency: [],
        postings: [],
        actual_vs_contract: [],
        services: [],
        handled_vouchers: [],
        reload_on_demand: [],
      },
      toggleButtonText: "Untoggle"
    };
  },
  async created() {
    await this.getTableHeaders();
    await this.getStatusOptions();
  },
  async mounted() {
    document.addEventListener("monthChanged", async (e) => {
      await this.getData();
    });

    this.$eventBus.$on("groupChanged", async (group) => {
      this.group = group;
      await this.getData();
      await this.toggleAll();
    });

    await this.getData();
    this.fixGroupHeaders();

    if (window.location.hash) {
      this.openCommentsModalFromMail();
    }
    await this.toggleAll();
  },
  methods: {
    collapseAll() {
      this.$refs.table.collapseAll();
    },
    expandAll() {
      this.$refs.table.expandAll();
    },
    updatePagination(newPagination) {
      this.pagination = newPagination;
    },
    openCommentsModalFromMail() {
      const companyFragment = document.querySelector(window.location.hash);
      companyFragment.scrollIntoView();
      companyFragment.querySelector(".comment-icon").click();
    },
    toggleSelectedRow(value) {
      let index = this.selectedRows.indexOf(value);
      if (index == -1) {
        this.companyChecked(value)
        return this.selectedRows.push(value);
      }
      this.companyUnChecked(value)
      return this.selectedRows.splice(index, 1);
    },
    toggleAll() {
      var companyGroup = document.getElementsByClassName('company-group');      
      Array.prototype.forEach.call(companyGroup, function(el) {
        el.click();
      });
      this.toggleButtonText = this.toggleButtonText === "Toggle" ? "Untoggle" : "Toggle";
    },
    toggleGroupCompanies(element) {
      let toBeToggled = this.data.filter(item => item.groupKey == element);

      if (toBeToggled.length < 1){return;}

      for (const item of toBeToggled){
           this.toggleSelectedRow(item.id)
      }
    },
    companyChecked(value){
     let item = this.data.find(item => item.id == value);

     this.$eventBus.$emit("companyChecked", item.groupKey, item.id);
    },
    companyUnChecked(value){
     let item = this.data.find(item => item.id == value);

     this.$eventBus.$emit("companyUnChecked", item.groupKey, item.id);
    },
    selectAll() {
      this.selectedRows = [];
      this.selectedRows = this.companyIds;
      this.$eventBus.$emit("selectAll");
      this.selectAllRows = true;
    },
    deselectAll() {
      this.selectedRows = [];
      this.selectAllRows = false;
    },
    DoubleScroll(element) {
      if (!document.querySelector(".scrollbar-top")) {
        var scrollbar = document.createElement("div");
        scrollbar.appendChild(document.createElement("div"));
        scrollbar.style.overflow = "auto";
        scrollbar.style.overflowY = "hidden";
        scrollbar.classList.add("scrollbar-top");
        scrollbar.style.marginLeft = "365px";
        scrollbar.firstChild.style.height = "1px";
        scrollbar.firstChild.style.width =
          document.querySelector(".v-datatable.v-table").getBoundingClientRect()
            .width + "px";
      } else {
        var scrollbar = document.querySelector(".scrollbar-top");
        scrollbar.firstChild.style.width =
          document.querySelector(".v-datatable.v-table").getBoundingClientRect()
            .width + "px";
      }

      scrollbar.firstChild.appendChild(document.createTextNode("\xA0"));
      var running = false;
      scrollbar.onscroll = function () {
        if (running) {
          running = false;
          return;
        }
        running = true;
        element.scrollLeft = scrollbar.scrollLeft;
      };
      element.onscroll = function () {
        if (running) {
          running = false;
          return;
        }
        running = true;
        scrollbar.scrollLeft = element.scrollLeft;
      };
      element.parentNode.insertBefore(scrollbar, element);
    },
    clearFilters(column) {
      this.filters[column] = [];
    },
    setFilters(value, column) {
      let filter = this.filters[column];
      let index = filter.indexOf(value);

      if (index == -1) {
        return typeof value == "object"
          ? filter.push(value[0])
          : filter.push(value);
      }

      return filter.splice(index, 1);
    },
    sortData(data) {
      data.sort((a, b) => {
        if (this.pagination.sortBy === "name") {
          if (!this.pagination.descending) {
            return a["name"].localeCompare(b["name"]);
          } else {
            return b["name"].localeCompare(a["name"]);
          }
        }
      });
      return data;
    },
    resetHeaders() {
      this.selectedHeaders = [];
      this.availableHeaders = [];
      Object.keys(this.originalHeaders).forEach((key) => {
        let header = {
          value: key,
          text: this.originalHeaders[key],
          locked: false,
          selected: true,
        };
        this.selectedHeaders.push(header);
      });
    },
    saveHeaders() {
      let body = this.selectedHeaders.concat(this.availableHeaders);
      body.unshift(this.fixedHeader);
      axios
        .post("/dashboard/admin/v3/dashboard-settings", body)
        .then((res) => {
          this.$refs.snackbar.toggleSnackbar("Saved", "success");
        })
        .catch((error) => {});
    },
    closeColumnEditor() {
      this.showColumnEditor = false;
    },
    headersSorted(e) {
      this.selectedHeaders.splice(
        e.newIndex,
        0,
        this.selectedHeaders.splice(e.oldIndex, 1)[0]
      );
      this.selectedHeaders.forEach(function (item, index) {
        item.order = index;
      });
    },
    toggleHeader(value, selected) {
      if (selected) {
        for (let i = 0; i < this.selectedHeaders.length; i++) {
          const header = this.selectedHeaders[i];

          if (header.value === value) {
            header.selected = false;
            this.availableHeaders.push(header);
            return this.selectedHeaders.splice(i, 1);
          }
        }
      }

      for (let i = 0; i < this.availableHeaders.length; i++) {
        const header = this.availableHeaders[i];

        if (header.value === value) {
          header.selected = true;
          this.selectedHeaders.push(header);
          return this.availableHeaders.splice(i, 1);
        }
      }
    },
    columnValueList(val) {
      return this.data.map((d) => d[val]);
    },
    changeSort(column) {
      if (column === "name") {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
      }
    },
    reportingPeriod() {
      let reportingPeriod = document.querySelector("#reporting-period").value;

      return reportingPeriod;
    },
    toPascalCase(word) {
      word = word.replaceAll("_", " ");
      return word
        .match(/[a-z]+/gi)
        .map((word) => {
          return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
        })
        .join("");
      return word;
    },
    fixGroupHeaders() {
      let groups = document.querySelectorAll(".v-datatable__group-row");

      groups.forEach((group) => {
        if (group.querySelector(".hide-group-header")) {
          group.style.display = "none";
        }
      });
    },
    async getTableHeaders() {
      await axios.get("/dashboard/admin/v3/table-headers").then((res) => {
        let data = res.data;
        this.originalHeaders = data.original_headers;

        res.data.headers.forEach((item) => {
          if (item.value != "name") {
            let header = {
              value: item.value,
              text: item.text,
              locked: false,
              selected: item.selected,
              filterable: item.value !== "active_services",
            };

            if (header.selected) {
              this.selectedHeaders.push(header);
            } else {
              this.availableHeaders.push(header);
            }
          } else {
            this.fixedHeader = {
              value: item.value,
              text: item.text,
              locked: true,
              width: "300px",
              fixed: true,
              filterable: true,
            };
          }
        });
      });
    },
    async getStatusOptions() {
      await axios.get("/dashboard/admin/v3/status-options").then((res) => {
        let data = res.data;
        this.statusOptions = data;
      });
    },
    async getData() {
      this.loading = true;
      await axios
        .get(`/dashboard/admin/v3/all/${this.reportingPeriod()}/${this.group}`)
        .then((res) => {
          this.data = res.data;

          this.renderComponent = false;
          this.loading = false;

          this.$nextTick(() => {
            this.renderComponent = true;
            this.$nextTick(() => {
              this.DoubleScroll(document.querySelector(".v-table__overflow"));
              this.fixGroupHeaders();
            });
          });
        })
        .catch((e) => {
          // handle error
        });
    },
    bustCache() {
      axios.get(
        `/dashboard/admin/v3/cache-bust/${this.reportingPeriod()}/${this.group}`
      );
      this.getData();
    },
    updateDataField(body) {
      body.reporting_period = this.reportingPeriod();
      axios.post("/setDataField", body).then((res) => {});
    },
    setVatStatus(body) {
      body.reporting_period = this.reportingPeriod();
      axios.post("/setVatStatus", body).then((res) => {});
    },
    toggleSalaryOutput(body) {
      body.reporting_period = this.reportingPeriod();
      body.company_grouping = "my_clients";
      axios.post("/toggleSalaryOutput", body).then((res) => {});
    },
    bulkEditVatStatus(option) {
      this.loading = true;
      let body = {
        reporting_period: this.reportingPeriod(),
        companies: this.selectedRows,
        data_field_id: option.data_field_id,
        data_field_group: option.data_field_group,
        data_field_approve: option.data_field_status,
      };
      axios
        .post("/bulk-edit/setVatStatus", body)
        .then((res) => {
          this.getData();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    bulkEdit(option) {
      this.loading = true;
      let body = {
        reporting_period: this.reportingPeriod(),
        companies: this.selectedRows,
        data_field_id: option.data_field_id,
        data_field_group: option.data_field_group,
        data_field_approve: option.data_field_status,
      };
      axios.post("/bulk-edit/setDataField", body).then((res) => {
        this.getData();
      });
    },
  },
};
</script>


<style lang="scss">
.table-header {
  .list-group-item :first-child:not([type="text"]) {
    margin-right: 0rem;
  }

  &-inner {
    justify-content: space-between;
    padding-top: 0px;
    padding-bottom: 0px;
  }
}

.v-datatable-root table.v-table.fixed-columns-table {
  table-layout: unset;
}

.v-datatable-root {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  tr {
    border: none;

    &:last-of-type {
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    }

    background-color: #fff;

    td.fixed-column {
      margin-left: var(--margin-left);
      background-color: #fff;
    }

    &:hover {
      background-color: #eee;

      td.fixed-column {
        background-color: #eee;
      }
    }

    &.is-in-group:hover {
      background-color: #fff !important;
      td.fixed-column {
        background-color: #fff !important;
      }
    }
  }

  td {
    border: none;
    border-right: 1px solid rgba(0, 0, 0, 0.12);

    &.fixed-column {
      background-color: #fff;

      &.last-fixed-column {
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      }
    }
  }

  th {
    text-align: center !important;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-left: 1px solid rgba(0, 0, 0, 0.12);
    &.fixed-column.last-fixed-column {
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      left: 0px;
    }
  }

  @media (min-width: 0) {
    .text-xs-left {
      text-align: center !important;
    }
  }

  table.v-table tbody td,
  .v-datatable-root table.v-table tbody th {
    height: 53px;
  }

  .v-select__slot {
    height: 40px;
  }

  .filter-header {
    height: 53px !important;
  }
}

td.fixed-column {
  white-space: normal;
  width: 300px;
  margin-left: 65px;
  left: 0px !important;
  &.checkbox-column {
    margin-left: 0px !important;
    left: 0px !important;
    width: 65px !important;
  }
}

.d-flex {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .bmd-form-group {
    padding-top: 0;
    display: block;
  }

  .btn {
    position: relative;
    z-index: 10;
    font-size: 14px !important;
    margin-bottom: 0 !important;
    border-radius: 0.25rem !important;
    display: block;
    margin-left: auto;
    padding: 9.5px 12px;
  }
}

input.search-input {
  display: block;
  font-size: 12px;
  padding: 9px;
  width: 400px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  appearance: none;
  padding-bottom: 5px;
  margin: {
    right: 15px !important;
    top: 25px;
    bottom: 25px;
  }
  padding: 12px 0px 10px 12px;
  border-radius: 0.25rem;

  &.focus-visible {
    outline: none;
    border: 1px solid rgba(0, 0, 0, 0.5);
  }

  &:foucs {
    outline: none;
  }
}

.loading {
  opacity: 0.5;
}

.columns-editor-container {
  position: relative;
  z-index: 10;
}

th.column {
  position: relative;
}

.scrollbar-top {
  &::-webkit-scrollbar {
    width: 6px;
    height: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: gainsboro;
    border-radius: 5px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #000000a2;
    border-radius: 5px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

.v-table__overflow {
  margin-left: var(--margin-left) !important;
  min-height: 100vh;
}

.v-datatable__group-row {
  z-index: 0;
}

.last-fixed-column.filtered {
  z-index: 1;
}

.v-datatable__group-col,
.v-datatable__group-row {
  left: 0px !important;
  margin-left: 0px !important;
}

.v-datatable__group-content {
  margin-left: 85px;
  z-index: 0;
}
td.group-title{
  margin-left: 65px !important;
  padding-left: 45px !important;
  z-index: -1;
}

tr.actions {
  position: absolute;
  left: 0;
  z-index: 10;
  width: 100%;
  display: flex;
  border-top: 1px solid rgba(0, 0, 0, 0.12);

  th {
    display: flex;
    align-items: center;
  }
}

tr.selected td,
tr.selected td.fixed-column {
  background-color: #b1b1b142 !important;
}

.v-datatable__actions__select {
  display: none;
}

.btn-refresh {
  padding: 9.3px 10px !important;
  display: flex !important;
  justify-content: center;
  align-items: center;
}

#dashboard-table .col-md-4 {
  padding-right: 12px !important;
}

.filtered span {
  font-weight: bolder;
}

.v-badge {
  display: inline-block;
  position: relative;
}

.badge-wrapper {
  flex: 0 1;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  widows: 100%;

  .badge {
    background-color: #4caf50 !important;
    border-color: #4caf50 !important;
    color: #fff;
    font-size: 9px;
    letter-spacing: 0;
    pointer-events: auto;
    position: absolute;
    text-align: center;
    text-indent: 0;
    white-space: nowrap;
    border-radius: 1000px;
    height: 12px;
    min-width: 0;
    padding: 0;
    width: 12px;
    inset: auto calc(100% - 8px) calc(100% - 8px) auto;
  }
}

tr.v-datatable__group-row,
tr.v-datatable__group-row ~ .is-in-group {
  background-color: #f5f5f5 !important;

  .fixed-column {
    background-color: #f5f5f5 !important;
  }
}

tr.v-datatable__group-row:nth-of-type(2n),
tr.v-datatable__group-row:nth-of-type(2n) ~ .is-in-group {
  background-color: #ebeff1 !important;

  .fixed-column {
    background-color: #ebeff1 !important;
  }
}

tr.v-datatable__group-row:nth-of-type(2n) ~ .is-in-group:hover {
  background-color: #fff !important;
}

tr:not(.v-datatable__group-row):nth-last-child(-n + 6) {
  .dropdown .items {
    transform: translateY(-112%);
  }
}

tr:not(.v-datatable__group-row):nth-child(1),
tr:not(.v-datatable__group-row):nth-child(2),
tr:not(.v-datatable__group-row):nth-child(3),
tr:not(.v-datatable__group-row):nth-child(4)
{
  .dropdown .items {
    transform: translateY(0%) !important;
  }
}

.toggle-button {
    position: relative;
    z-index: 10;
    font-size: 14px !important;
    margin-bottom: 0 !important;
    border-radius: 0.25rem !important;
    display: block;
    margin-left: auto;
    padding: 9.5px 12px;
    background: none;
    color: #f5f5f5;
    border-style: solid;
    border-width: 1px;
    border-color: #f5f5f5;
    margin-right: 15px;
    &.toggle-button:hover {
      cursor: pointer;
    }
  }
</style>

